export const API=process.env.REACT_APP_BACKEND
export const DOMAINNAME=process.env.DOMAIN
export const REELS_URL=process.env.REACT_APP_REELS_URL || "/reels/"
